export default "__VITE_ASSET__ClTZp30___"